export const homeworkDictionary = {
  sending: 'Jo`natilmoqda...',
  homeworkStatus: 'Uy vazifa statusi',
  clickedHomeworkButton: 'Homework yuborish buttoni bosildi',
  clickedExamButton: 'Exam yuborish buttoni bosildi ',
}
